import { createSlice } from "@reduxjs/toolkit";
import { english } from "./english";
import { spanish } from "./spanish";
import { portuguese } from "./portuguese";

export const langSlice = createSlice({
  name: "lang",
  initialState: {
    lang: "es",
    dictionary: spanish,
  },
  reducers: {
    setLang: (state, { payload }) => {
      state.lang = payload;
      state.dictionary = payload === "es" ? spanish : payload === "pt" ? portuguese : english;
    },
  },
});

export const { setLang } = langSlice.actions;
